import { formatCurrency } from "./currency";

export const km = (value) => {
    if (value !== null && value !== undefined) {
        return `${value.toFixed(2)} km`;
    }
    return "";
};

export const cityTax = (type, value, currency = "EUR") => {
    switch (type) {
        case "percent": {
            return `${value.toFixed(2)}%`;
        }
        case "pax": {
            const _value = formatCurrency(value, currency);
            return `${_value} per pax/night`;
        }
        case "room": {
            const _value = formatCurrency(value, currency);
            return `${_value} per room/night`;
        }
    }
    return "";
};

export default function (app) {
    app.config.globalProperties.$fmt = {
        km,
        cityTax,
    };
}
